import { takeLatest, all } from "redux-saga/effects";
import sagasManager from "Utils/sagasManager";

import { signin, forgotPassword, postForgotPasswordDetails, resetPassword, requestOTP, loginWithOTP, loginWithSSO,
   ssoUserValidate, ssoDeleteToken, getBroadcastMsg, ssoConfig, validateForgotPassword } from "Sagas/authentication";

import {
   getGroupsAndTransporters,
   getTransportersList,
   createRFQ,
   getTrips,
   addTrip,
   getRfqs,
   getContractedRfqs,
   getContractedRfqsBetweenDates,
   getContractedRfqDetails,
   uploadDocument,
   discardfRfq,
   deleteTrip,
   getRFQDetail,
   copyRfq,
   postBid,
   fetchBids,
   fetchSeekerBids,
   getRFQDownloadTemplate,
   uploadRFQ,
   createFreshRFQ,
   uploadTrips,
   getTripsDownloadTemplate,
   getQBR,
   sendSFTP,
   getAllLocations,
   uploadCPFormInfo,
   downloadCPFormInfo,
   getAutoSuggestLocations,
   postCancelRFQ,
   getAllSubPlants,
   getNetworkDetails,
   getRouteCode,
   saveRouteCode,
   editHeadingCharges,
   deleteAddedTrip,
   getCourierTrips,
   postCourierTrips,
   courierPostBid,
   getServiceCategory,
   updateServiceCategory,
   getTransporterBidCommonCharges,
   downloadAuditTrailFormInfo,
   downloadMarketSiteRateInfo,
   getLocationWithPincode,
   getDieselPriceDetails,
   getSAPRouteCodes,
   createFreshEvent,
   getRFQEvent,
   cancelEvent,
   postEventDetails,
   postWishlistEvent,
   updateRFQLevelVendorBiddingStatus,
   uploadContainerTrips,
   downloadContainerTripsTemplate,
   getContainerTrips,
   postContainerTrips,
   getConatinerLPP,
   uploadExistingTripsRemarks,
   downloadExistingTripsRemarks,
   downloadUploadedFile,
   getEximLppDetails,
   getTermsAndConditions,
   postTollTaxUpdatePrice
} from 'Sagas/rfq';

import {
   getPackingTypes,
   getVehicleTypes,
   getVehicleBodyTypes,
   getPaymentCycles,
   getBusinesVolumes,
   getSlabs,
   getPricingBasis,
   getProductCategories,
   getGroups,
   getAllTransporters,
   createGroup,
   editGroup,
   deleteGroup,
   getHolistics,
   getMarketAnalysis,
   getAllocations,
   getBranches,
   getAllEndToEndMis,
   getAllIndentMis,
   getTransporterParticipation,
   getAllVoltasMis,  
   getServerTime,
   getSecondaryToLocation,
   getSecondaryUptoKmList,
   getMultiModalMis,
   tk11Efficiency,
   getCourierMovements,
   getCourierModes,
   getCourierZones,
   getCourierSlabs,
   getIPAddress,
   getManagementSummaryReport,
   getPlantWiseReport,
   getCurrencyDetails,
   getRFQTypes,
   getReportTemplate,
   getMarketRateReport,
   getLocationsForReports,
   getYardToYardConstants,
   getMultiModeContainerTypes,
   getMultiModeMovementTypes,
   getPlantLocationList,
   getDepotLocationList,
   getCHAList,
   getFreightDetailsReport,
   getCurrencyTypes,
   vendorWithDrawBid,
   updateStatus,
   getUploadPlanList,
   createUploadPlan,
   editUploadPlan,
   deleteUploadPlan,
   getConsigneeList,
   uploadFileUP,
   downloadUploadPlan,
   getContractingShortMIS,
   getGoogleStudioReport,
   getHolisticsTokenMIS,
   getIncotermsList,
   getCostHeadList,
   postSelectedNavBranch,
   getFuelTypes,
   getContractingIndentingReport,
   getSpotContractReasons,
   getProviderTK11Mis,
   getSeaAndAirLinesList,
   getContractTenureList,
   getFTLContractTypes,
   getYardLocations,
   getClusterDetails,
   getZoneWiseDetails,
   getCompanyBranchDetails,
   getVendorBiddingStatus,
   getMasterRouteCodeDetails,
   getVendorList,
   getCFADetails,
   getMultiContractTypes,
   getTripTypes,
   getContainerTypes,
   getContainerListType,
   getMultiModeRouteCode,
   getStatesDropdown,
   getSearchedSecondaryCotractRfqTrips,
   getSourceICDBranches,
   getAllICDBranches,
   getICDDestinationRouteCode,
   getConsigneeDetailsByName,
   getSeekerCompanylist,
   getPortDetails,
   getEXIMAWLPlantWiseCostHeads
} from 'Sagas/constants';

import {
   postChallengePrice,
   postCPformMegaSave,
   getTransporterBids,
   sendLOI,
   postCounter,
   postCounterForSeeker,
   acceptRejectLoi,
   acceptRejectCP,
   changeBidEnd,
   getTransporters,
   getDownloadBiddingDetails,
   uploadBiddingDetails,
   postChallengePriceForm,
   getLPPDetails,
   changeTripBidEnd,
   getCPLPPDetails,
   sendExtendDate,
   sendLOIForApprover,
   sendApproverMessageForUser,
   updateTk11Data,
   deleteTripDetails,
   changeTripBaseVolume,
   postOtherCostCP,
   otherCostAcceptRejectCP,
   getDownloadBiddingTrailDetails,
	getCourierServiceCategory,
   uploadCourierServiceCategory,
   clearMessage,
   getSystemSuggestedPrice,
   checkContractExist,
   calculateFreightRate,
   getOtherLPPDetails,
   getAmmendentlist,
   putAmmendmentApproval,
   getDownloadBiddingRate,
   uploadBiddingRate,
   getDownloadTrucksDetails,
   uploadTrucksDetails,
   saveNumberOfVehiclePlaced,
   getExistingContracts,
   postGenerateContractDetails,
   uploadMultiModeContracts,
   downloadMultiModeContracts,
   getGeneratedContracts,
   rfqClosed,
   acceptanceCeilingPrice,
   cancelledLoi,
   downloadAwlMultiModeTemplate,
   uploadAwlMultiModeTrips,
   getCargoShipmentTrackingData,
   revokeWithdrawBid,
   getRouteMaster,
   addRouteMaster,
   updateRouteMaster,
   deleteRouteMaster,
   uploadRouteMaster,
   downloadRouteMasterDetails,
   downloadRouteMasterTemplate,
   checkFtlContractExist,
   postSOBDetails,
   updateDPHDetails,
   postTripLevelContractExtension,
   postTripLevelBidExtension,
   approverRejectsLoi,
   downloadExistingContractTemplate,
   uploadExistingContract,
   uploadRFQFile,
   postCreateIndents,
   deleteUploadedFile,
   postDPHApproval,
   postApproveDPH,
   retriggerTK11ForRFQ,
   getEventManagementDetails,
   deleteEventDetails,
   downloadEventDetailTemplate,
   uploadRFQsforEvent,
   scheduleEvent,
   getEventStatus,
   getEventRFQTrips,
   updateEventRFQ,
   updateEventRFQTrips,
   uploadSOBDetails,
   downloadSOBTemplate,
   getWinningTransporters,
   deleteTransporterInWinningPage,
   downloadOfflineSlabWiseTrips,
   uploadOfflineSlabWiseTrips,
   getMasterContracts,
   getFromRoutes,
   getBranchYardFilters,
   postSearchRoutes,
   getGenerateRouteCodes,
   addAdditionalTransporter,
   getRfqlevelPRDetails,
   getTransporterlevelPRDetails,
   downloadPRDetails,
   generatePlanInMasterContract,
   getContractDetails,
   getChildContractTk11,
   getMasterContractTk11,
   uploadOtherCharges,
   getOtherChargesTemplate,
   updatePostBidToPreBidRFQ,
   downloadTransporterWiseBidDetails,
   retriggerMasterContract, 
   saveRetriggerMasterContract,
   getLocationDropdownValues,
   getSecondaryContractlist,
   downloadTripsSecondaryContractsTripsTemplate,
   uploadSecondaryContractsTrips,
   saveSecondaryContracts,
   deleteSecondaryContractRFQ,
   deleteSecondaryContractRFQTrips,
   getContractByRFQId,
   updateSecondaryContrats,
   multiContractSendLoiForApproval,
   approveMultiContract,
   rejectMultiContract,
   postTripFileRemarks,
   downloadMultiContractTemplate,
   uploadMultiContract,
   getMultiContracts,
   deleteMultiContract,
   updateMultiContract,
   downloadOfflineContractsDetails,
   postOfflineContractsUpdatedDetails,
   postOverallAllocation,
   updateSingleBiddedTripsTime,
   postSecondaryContractValidation,
   reactivateTk11,
   getTripsErrorLogs,
   deleteContractRecord
} from "Sagas/contracting";

import {
   sendChatMessage,
   getChatMessages
} from 'Sagas/chat';

import {
   SIGN_IN,
   FORGOT_PASSWORD,

   FETCH_BIDS,
   POST_BID,
   GET_GROUPS_AND_TRANSPORTERS,
   GET_TRANSPORTERS_LIST,
   CREATE_RFQ,
   CREATE_FRESH_RFQ,
   GET_TRIPS,
   ADD_TRIP,
   GET_RFQS,
   GET_RFQS_CONTRACT,
   GET_RFQS_CONTRACT_DETAILS,
   FETCH_CONTRACTED_RFQS_BETWEEN_DATES,
   UPLOAD_DOCUMENT,
   DISCARD_RFQ,
   DELETE_TRIP,
   GET_RFQ_DETAIL,
   COPY_RFQ,

   GET_PACKING_TYPES,
   GET_VEHICLE_TYPES,
   GET_VEHICLE_BODY_TYPES,
   GET_PAYMENT_CYCLES,
   GET_BUSINESS_VOLUMES,
   GET_SLABS,
   GET_PRICING_BASIS,
   GET_PRODUCT_CATEGORIES,

   FETCH_SEEKER_BIDS,
   CHALLENGE_PRICE,
   GET_SEEKER_TRANSPORTERS,
   GET_SEEKER_TRANSPORTER_BIDS,

   COUNTER_PRICE,
   COUNTER_PRICE_FOR_SEEKER,
   SEND_LOI,
   ACCEPT_REJECT_LOI,
   ACCEPT_REJECT_CP,
   CHANGE_BID_END,
   CHANGE_TRIP_BID_END,

   SEND_CHAT_MESSAGE,
   GET_CHAT_MESSAGES,

   DOWNLOAD_RFQ_TEMPLATE,
   UPLOAD_RFQ,
   UPLOAD_TRIPS,
   DOWNLOAD_TRIPS_TEMPLATE,

   GET_GROUPS,
   GET_TRANSPORTERS,
   CREATE_GROUP,
   EDIT_GROUP,
   DELETE_GROUP,

   DOWNLOAD_BIDDING_DETAILS,
   UPLOAD_BIDDING_DETAILS,

   GET_QBR,
   POST_CHALLENGE_PRICE_FORM,
   CP_FORM_MEGA_SAVE,
   GET_LPP_DETAILS,
   GET_CP_LPP_DETAILS,
   GET_BRANCHES,

   SEND_SFTP,
   GET_ALL_LOCATIONS,
   GET_AUTO_SUGGEST_LOCATIONS,

   GET_MARKET_ANALYSIS,
   GET_ALLOCATIONS_REPORT,

   UPLOAD_CP_FORM,
   DOWNLOAD_CP_FORM,
   CANCEL_RFQ,
   FORGOT_PASSWORD_DETAILS,
   GET_ALL_SUBPLANTS,
   CHANGE_PASSWORD_DETAILS,
   GET_END_TO_END_MIS,
   SAVE_EXTEND_DATE_DETAILS,
   INDENT_MIS,
   ADD_LOI_APPROVER,
   SEND_APPROVER_LOI_MESSAGE,
   GET_NETWORK_DETAILS,
   GET_TRANSPORTER_PARTICIPATION,
   GET_VOLTAS_MIS,
   UPDATE_TK11,
   DELETE_TRIP_DETAILS,
   CHANGE_TRIP_BASE_VOLUME,
   GET_ROUTE_CODE,
   SAVE_ROUTE_CODE,
   EDIT_HEADING_CHARGES_URL,
   GET_SERVER_TIME,
   DELETE_ADDED_TRIP,
   GET_SECONDARY_TO_LOCATION,
   OTHER_COST_CHALLENGE_PRICE,
   OTHER_COST_ACCEPT_REJECT_CP,
   GET_SECONDARY_UPTO_KM_LIST,
   GET_MULTI_MODAL_REPORT,
   DOWNLOAD_BIDDING_TRAIL,
   GET_TK11_EFFICIENCY_MIS,
   GET_MOVEMENTS,
   GET_MODES,
   GET_ZONES,
   GET_COURIER_SLABS,
   GET_COURIER_TRIPS,
   POST_COURIER_TRIPS,
   POST_COURIER_POST_BID,
	PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE,
   PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE,
   GET_SERVICE_CATEGORY,
   UPDATE_SERVICE_CATEGORY,
   GET_TRANSPORTER_BID_COMMON_CHARGES,
   GET_IP_ADDRESS,
   CLEAR_MESSAGE,
   GET_PLANT_WISE_REPORT,
   GET_MANAGEMENT_SUMMARY_REPORT,
   GET_CURRENCY_DETAILS,
   GET_RFQ_TYPES,
   GET_SYSTEM_SUGGESTED_PRICE,
   GET_REPORT_TEMPLATE,
   POST_MARKET_RATE_REPORT,
   DOWNLOAD_AUDIT_TRAIL_FORM,
   GET_MARKET_REPORT_LOCATIONS,
   CHECK_CONTRACT_EXIST,
   GET_YARD_TO_YRAD_CONSTANTS_LIST,
   CALUCALATE_FREIGHT_RATE,
   GET_OTHER_LPP_DETAILS,
   GET_AMMENDMENT_LIST_DATA,
   PUT_AMMENDMENT_APPROVE_DATA,
   DOWNLOAD_MARKET_SITE_RATE_DETAILS,
   DOWNLOAD_BIDDING_RATE,
   UPLOAD_BIDDING_RATE,
   DOWNLOAD_TRUCKS,
   UPLOAD_NUMBER_OF_TRUCKS,
   NUMBER_OF_VEHICLE_PLACED,
   GET_EXISTING_CONTRACT_DETAILS,
   POST_GENERATE_CONTRACT_DETAILS,
   DOWNLOAD_MULTI_MODE_CONTRACTS,
   UPLOAD_MULTI_MODE_CONTRACTS,
   GET_GENERATED_CONTRACT_DETAILS,
   GET_MULTI_MODE_CONTAINER_LIST,
   GET_MULTI_MODE_MOVEMENT_TYPE_LIST,
   GET_PLANT_LOCATION_LIST,
   GET_DEPOT_LOCATION_LIST,
   GET_CHA_LIST,
   GET_FREIGHT_DETAILS_REPORT,
   GET_CURRENCY_TYPES,
   VENDOR_WITH_DRAW_BID,
   REVOKE_WITHDRAW_BID,
   CLOSED_RFQ,
   ACCEPTANCE_CEILING_PRICE,
   STATUS_GROUP,
   LOI_CANCELLED,
   GET_UPLOAD_PLAN,
   POST_UPLOAD_PLAN,
   UPDATE_UPLOAD_PLAN,
   DELETE_UPLOAD_PLAN,
   GET_CONSIGNEE,
   UPLOAD_UP_FILE,
   DOWNLOAD_UP_TEMPLATE,
   GET_CONTRACTING_SHORT_MIS,
   DOWNLOAD_AWL_MULTIMODE_TEMPLATE,
   UPLOAD_AWL_MULTIMODE_TRIPS,
   GET_LOCATION_WITH_PINCODE,
   GET_GOOGLE_STUDIO_REPORT,
   GET_HOLISTICS_TOKEN,
   GET_INCOTERMS_LIST,
   GET_COST_HEADS_LIST,
   GET_CARGO_SHIPMENT_TRACKING_DATA,
   GET_DIESEL_PRICE,
   POST_SELECTED_BRANCH_DETAILS,
   GET_FUEL_TYPES,
   REQUEST_OTP,
   LOGIN_WITH_OTP,
   LOGIN_WITH_SSO,
   VALIDATE_SSO_USER,
   GET_CONTRACTING_INDENTING_MIS,
   SSO_DELETE_TOKEN,
   GET_BROADCAST_MSG,
   GET_SPOT_CONTRACT_REASONS,
   GET_PROVIDER_TK11_MIS,
   GET_SEA_AND_AIR_LINES_LIST,
   GET_ROUTE_MASTER_DETAILS,
   ADD_ROUTE_MASTER_DETAILS,
   UPDATE_ROUTE_MASTER_DETAILS,
   DELETE_ROUTE_MASTER_DETAILS,
   UPLOAD_ROUTE_MASTER_DETAILS,
   DOWNLOAD_ROUTE_MASTER_DETAILS,
   DOWNLOAD_ROUTE_MASTER_TEMPLATE,
   CHECK_FTL_CONTRACT_EXIST,
   GET_CONTRACT_TENURE_LIST,
   POST_SHARE_OF_BUSINESS,
   UPDATE_DPH_DETAILS,
   TRIP_LEVEL_CONTRACT_EXTENSION,
   TRIP_LEVEL_BID_EXTENSION,
   GET_SAP_ROUTE_CODES,
   POST_REJECT_LOI_FROM_APPROVER,
   GET_SSO_CONFIG,
   DOWNLOAD_EXISTING_CONTRACT_TEMPlATE,
   UPLOAD_EXISTING_CONTRACT_DETAILS,
   UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ,
   POST_CREATE_INDENTS,
   DELETE_UPLOADED_FILE,
   POST_DPH_APPROVAL,
   POST_APPROVE_DPH,
   RETRIGGER_TK11_FOR_RFQ,
   GET_EVENT_DETAILS,
   DELETE_EVENT_DETAILS,
   CREATE_NEW_EVENT,
   GET_RFQ_EVENT,
   CANCEL_EVENT,
   POST_EVENT_DETAILS,
   DOWNLOAD_EVENT_DETAILS_TEMPLATE,
   UPLOAD_RFQS_FOR_EVENT,
   SCHEDULE_EVENT,
   GET_EVENT_STATUS,
   GET_EVENT_RFQ_TRIPS,
   UPDATE_EVENT_RFQ,
   UPDATE_EVENT_RFQ_TRIPS,
   UPLOAD_SOB_DETAILS,
   DOWNLOAD_SOB_TEMPLATE,
   GET_WINNING_TRANSPORTERS,
   DELETE_TRANSPORTER_IN_WINNIG_PAGE,
   POST_WISHLIST_EVENT,
   GET_FTL_CONTRACT_TYPE,
   DOWNLOAD_OFFLINE_SLABEWISE_TRIPS,
   UPLOAD_OFFLINE_SLABEWISE_TRIPS,
   GET_ALL_MASTER_CONTRACTS,
   GET_FROM_ROUTE,
   GET_BRANCH_YARD_FILTERS,
   POST_SEARCH_ROUTES_CONTRACTS,
   GET_YARD_LOCATIONS,
   GET_GENERATE_ROUTE_CODE,
   ADD_ADDITIONAL_TRANSPORTER_DURING_BIDDING,
   GET_RFQ_LEVEL_PR_DETAILS,
   GET_TRANSPORTER_LEVEL_PR_DETAILS,
   DOWNLOAD_PR_DETAILS,
   GET_CLUSTER_DETAILS,
   GENERATE_PLAN_IN_MASTER_CONTRACT,
   GET_CONTRACT_DETAILS,
   GET_CHILD_CONTRACT_TK11,
   GET_MASTER_CONTRACT_TK11,
   GET_ZONE_WISE_DETAILS,
   GET_COMPANY_BRANCH_DETAILS,
   GET_VENDOR_BIDDING_STATUS,
   UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS,
   GET_OTHER_CHARGES_TEMPLATE,
   UPLOAD_OTHER_CHARGES,
   UPDATE_POST_BID_TO_PRE_BID_RFQ,
   DOWNLOAD_TRANSPORTER_WISE_BID_DETAILS,
   RETRIGGER_MASTER_CONTRACTS_TK11,
   SAVE_RETRIGGER_MC_TK11,
   GET_LOCATION_DROPDOWN_VALUES,
   GET_MASTER_ROUTE_CODE_DETAILS,
   GET_SECONDARY_CONTRACTS_LIST,
   GET_VENDOR_LIST,
   UPLOAD_SECONDARY_CONTRACT_TRIPS,
   DOWNLOAD_SECONDARY_CONTRACT_TEMPLATE,
   SAVE_SECONDARY_CONTRACTS,
   DELETE_SECONDARY_CONTRACT_RFQ,
   GET_CONTRACT_BY_RFQId,
   GET_SECONDARY_CONTRACT_CFA_DETAILS,
   UPDATE_SECONDARY_CONTRACTS,
   MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL,
   APPROVE_MULTI_CONTRACT,
   REJECT_MULTI_CONTRACT,
   DOWNLOAD_MULTI_CONTRACT_TEMP,
   UPLOAD_MULTI_CONTRACT,
   GET_MULTI_CONTRACT_DETAILS,
   DELETE_MULTI_CONTRACT,
   GET_MULTI_CONTRACT_TYPES,
   UPDATE_MULTI_CONTRACT,
   GET_TRIP_TYPES,
   GET_CONTAINER_TYPES,
   GET_CONTAINER_TYPES_LIST,
   GET_MULTI_MODE_ROUTE_CODE,
   UPLOAD_CONTAINER_TRIPS,
   DOWNLOAD_CONTAINER_TEMPLATE,
   GET_CONTAINER_TRIPS,
   POST_CONTAINER_TRIPS,
   GET_CONTAINER_LPP,
   UPLOAD_EXTISTING_TRIPS_REMARKS,
   DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE,
   DOWNLOAD_UPLOADED_FILE,
   GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE,
   POST_OFFLINE_CONTRACTS_UPDATED_DETAILS,
   POST_TRIP_FILE_REMARKS,
   GET_REGION_NAMES,
   GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST,
   GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST,
   GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST,
   GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST,
   GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST,
   GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST,
   GET_EXIM_CARGO_TEMPLATE,
   UPLOAD_EXIM_CARGO_TEMPLATE,
   GET_EXIM_CONTAINER_BL_TRACKING_DETAILS,
   GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
   GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
   POST_ACCEPT_CEILING_PRICE_LOI,
   GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST,
   GET_RAIL_RAKE_LIST,
   GET_ORIGIN_DESTINATION_YARD_LIST,
   GET_CONSIGNOR_PICKUP_LOCATION_LIST,
   GET_SERVICE_TYPES_LIST,
   GET_SERVICE_MODE_TYPES_LIST,
   GET_CARGO_DETAILS_TYPES_LIST,
   GET_CARGO_MATERIAL_PACKING_TEMAPLATE,
   UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE,
   GET_HANDLING_INSTRUCTION_TYPES_LIST,
   GET_VEHICLE_TYPES_LIST,
   CREATE_SUPPLIER_CONTRACT,
   GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS,
   GET_PACKING_TYPES_LIST,
   GET_SUPPLIER_NAME_LIST,
   CREATE_TRANSPORTATION_RFQ,
   GET_SUPPLIER_DETAILS_RFQ,
   UPDATE_SUPPLIER_CONTRACT_DETAILS,
   DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS,
   GET_TRANSPORTER_MAPPING_LIST,
   GET_PROVIDER_MATERIAL_PACKING_DETAILS,
   POST_OVERALL_ALLOCATION,
   DELETE_SECONDARY_CONTRACT_RFQ_TRIP,
   UPLOAD_TARGET_PRICE,
   DOWNLOAD_TARGET_PRICE,
   GET_SEARCHED_SECONDARY_CONTRACT_RFQ_TRIPS,
   GET_SOURCE_ICD_BRANCH_LIST,
   GET_ALL_ICD_BRANCH_LIST,
   GET_ICD_DESTINATION_ROUTE_CODE,
   EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS,
   GET_CONSIGNEE_DETAILS_BY_NAME,
   GET_SEEKER_COMPANY_LIST,
   VALIDATE_FORGOT_PASSWORD,
   SECONDARY_CONTRACT_TENURE_VALIDATION,
   POST_ON_DEMAND_TRACKING,
   GET_PORT_DETAILS,
   GET_EXIM_LPP_DETAILS,
   REACTIVATE_TK11,
   SAVE_EXIM_CONTAINER_SKU_DETAILS,
   GET_EXIM_AWL_PLANT_WISE_COST_HEADS,
   GET_TRIPS_LOG,
   DELETE_CONTRACT_RECORD,
   GET_TERMS_AND_CONDITIONS,
   POST_TOLL_TAX_UPDATE_PRICE
} from 'Constants/actionConstants';
import { GET_HOLISTICS } from "Constants/actionConstants";

import {
   getMultimodeRateComparisonCommodityCategoryList,
   getMultimodeRateComparisonFreightDaysList,
   getMultimodeRateComparisonFreightRateList,
   getMultimodeRateComparisonSoureDestinationList,
   getMultimodeRateComparisonVehicleDetailsList,
   getMultimodeRateComparisonViewDetailsRailFreightRateList,
   getMultimodeRateComparisonViewDetailsRoadFreightRateList,
   getOriginDestinationYardList,
   getRailRakeList
} from "./rateComparison";

import {
   getEximCargoSourceDestinationPortAndStatus,
   getEximCargoTemplate,
   getEximContainerBlTrackingDetails,
   getEximContainerBlTrackingDetailsTemplate,
   uploadEximCargoTemplate,
   postOnDemandTracking,
   saveEximCargoDetailsSkuDetails
} from "./EXIMCargoTracking";

import {
   createSupplierContract,
   deleteSupplierContractRfqDetails,
   getCargoDetailsTypesList,
   getCargoMaterialPackingTemaplate,
   getConsignorPickupLocationList,
   getHandlingInstructionTypesList,
   getPackingTypesList,
   getServiceModeTypesList,
   getServiceTypesList,
   getVehicleTypesList,
   updateSupplierContractDetails,
   uploadCargoMaterialPackingTemaplate
} from "./supplierRFQCreateOrUpdateRequest";

import { 
   createTransportationRfq,
   getProviderMaterialPackingDetails,
   getSupplierDetailsRfq,
   getSupplierNameList, 
   getSupplierTransportationContractsDetails, 
   getTransporterMappingList
} from "./supplierOrTransportationRequestsDashboard";
import { commonSaga } from "./common";
import { poDetailsSaga } from "./poDetails";
import { transportationManagementSaga } from "./transportationManagement";


sagasManager.addSagaToRoot(function* rootSaga() {
   yield all([
      takeLatest(SIGN_IN, signin),
      takeLatest(FORGOT_PASSWORD, forgotPassword),
      takeLatest(GET_GROUPS_AND_TRANSPORTERS, getGroupsAndTransporters),
      takeLatest(GET_TRANSPORTERS_LIST, getTransportersList),
      takeLatest(CREATE_RFQ, createRFQ),
      takeLatest(CREATE_FRESH_RFQ, createFreshRFQ),
      takeLatest(GET_TRIPS, getTrips),
      takeLatest(ADD_TRIP, addTrip),
      takeLatest(GET_RFQS, getRfqs),
      takeLatest(GET_RFQS_CONTRACT, getContractedRfqs),
      takeLatest(GET_RFQS_CONTRACT_DETAILS, getContractedRfqDetails),
      takeLatest(FETCH_CONTRACTED_RFQS_BETWEEN_DATES, getContractedRfqsBetweenDates),
      takeLatest(UPLOAD_DOCUMENT, uploadDocument),
      takeLatest(DISCARD_RFQ, discardfRfq),
      takeLatest(DELETE_TRIP, deleteTrip),
      takeLatest(GET_RFQ_DETAIL, getRFQDetail),
      takeLatest(COPY_RFQ, copyRfq),

      takeLatest(GET_PACKING_TYPES, getPackingTypes),
      takeLatest(GET_VEHICLE_TYPES, getVehicleTypes),
      takeLatest(GET_VEHICLE_BODY_TYPES, getVehicleBodyTypes),
      takeLatest(GET_PAYMENT_CYCLES, getPaymentCycles),
      takeLatest(GET_BUSINESS_VOLUMES, getBusinesVolumes),
      takeLatest(GET_SLABS, getSlabs),
      takeLatest(GET_PRICING_BASIS, getPricingBasis),
      takeLatest(GET_PRODUCT_CATEGORIES, getProductCategories),


      takeLatest(POST_BID, postBid),
      takeLatest(FETCH_BIDS, fetchBids),
      takeLatest(FETCH_SEEKER_BIDS, fetchSeekerBids),
      takeLatest(CHALLENGE_PRICE, postChallengePrice),
      takeLatest(GET_SEEKER_TRANSPORTERS, getTransporters),
      takeLatest(GET_SEEKER_TRANSPORTER_BIDS, getTransporterBids),
      takeLatest(SEND_LOI, sendLOI),
      takeLatest(COUNTER_PRICE, postCounter),
      takeLatest(COUNTER_PRICE_FOR_SEEKER, postCounterForSeeker),
      takeLatest(ACCEPT_REJECT_LOI, acceptRejectLoi),
      takeLatest(ACCEPT_REJECT_CP, acceptRejectCP),
      takeLatest(CHANGE_BID_END, changeBidEnd),
      takeLatest(CHANGE_TRIP_BID_END, changeTripBidEnd),
      takeLatest(DOWNLOAD_BIDDING_DETAILS, getDownloadBiddingDetails),
      takeLatest(UPLOAD_BIDDING_DETAILS, uploadBiddingDetails),
      takeLatest(POST_CHALLENGE_PRICE_FORM, postChallengePriceForm),
      takeLatest(CP_FORM_MEGA_SAVE, postCPformMegaSave),

      takeLatest(SEND_CHAT_MESSAGE, sendChatMessage),
      takeLatest(GET_CHAT_MESSAGES, getChatMessages),

      takeLatest(DOWNLOAD_RFQ_TEMPLATE, getRFQDownloadTemplate),
      takeLatest(UPLOAD_RFQ, uploadRFQ),
      takeLatest(UPLOAD_TRIPS, uploadTrips),
      takeLatest(DOWNLOAD_TRIPS_TEMPLATE, getTripsDownloadTemplate),


      takeLatest(GET_GROUPS, getGroups),
      takeLatest(GET_TRANSPORTERS, getAllTransporters),
      takeLatest(CREATE_GROUP, createGroup),
      takeLatest(EDIT_GROUP, editGroup),
      takeLatest(DELETE_GROUP, deleteGroup),
      takeLatest(GET_QBR, getQBR),
      takeLatest(GET_HOLISTICS, getHolistics),
      takeLatest(GET_MARKET_ANALYSIS, getMarketAnalysis),
      takeLatest(GET_ALLOCATIONS_REPORT, getAllocations),


      takeLatest(GET_LPP_DETAILS, getLPPDetails),
      takeLatest(GET_CP_LPP_DETAILS, getCPLPPDetails),
      takeLatest(GET_BRANCHES, getBranches),


      takeLatest(SEND_SFTP, sendSFTP),
      takeLatest(GET_ALL_LOCATIONS, getAllLocations),
      takeLatest(GET_AUTO_SUGGEST_LOCATIONS, getAutoSuggestLocations),


      takeLatest(UPLOAD_CP_FORM, uploadCPFormInfo),
      takeLatest(DOWNLOAD_CP_FORM, downloadCPFormInfo),

      takeLatest(CANCEL_RFQ, postCancelRFQ),
      takeLatest(FORGOT_PASSWORD_DETAILS, postForgotPasswordDetails),

      takeLatest(GET_ALL_SUBPLANTS, getAllSubPlants),

      takeLatest(CHANGE_PASSWORD_DETAILS, resetPassword),

      takeLatest(GET_END_TO_END_MIS, getAllEndToEndMis),

      takeLatest(SAVE_EXTEND_DATE_DETAILS, sendExtendDate),

      takeLatest(INDENT_MIS, getAllIndentMis),

      takeLatest(ADD_LOI_APPROVER, sendLOIForApprover),
      takeLatest(SEND_APPROVER_LOI_MESSAGE, sendApproverMessageForUser),
      takeLatest(GET_NETWORK_DETAILS, getNetworkDetails),

      takeLatest(GET_TRANSPORTER_PARTICIPATION, getTransporterParticipation),

      takeLatest(GET_VOLTAS_MIS, getAllVoltasMis),
      takeLatest(UPDATE_TK11, updateTk11Data),

      takeLatest(DELETE_TRIP_DETAILS, deleteTripDetails),
      takeLatest(CHANGE_TRIP_BASE_VOLUME, changeTripBaseVolume),
      takeLatest(GET_ROUTE_CODE, getRouteCode),
      takeLatest(SAVE_ROUTE_CODE, saveRouteCode),
      takeLatest(EDIT_HEADING_CHARGES_URL, editHeadingCharges),

      takeLatest(GET_SERVER_TIME, getServerTime),
      takeLatest(DELETE_ADDED_TRIP, deleteAddedTrip),
      takeLatest(GET_SECONDARY_TO_LOCATION, getSecondaryToLocation),
      takeLatest(OTHER_COST_CHALLENGE_PRICE, postOtherCostCP),
      takeLatest(OTHER_COST_ACCEPT_REJECT_CP, otherCostAcceptRejectCP),
      takeLatest(GET_SECONDARY_UPTO_KM_LIST, getSecondaryUptoKmList),
      takeLatest(GET_MULTI_MODAL_REPORT, getMultiModalMis),
      takeLatest(DOWNLOAD_BIDDING_TRAIL, getDownloadBiddingTrailDetails),
      takeLatest(GET_TK11_EFFICIENCY_MIS, tk11Efficiency),
      takeLatest(GET_MOVEMENTS, getCourierMovements),
      takeLatest(GET_MODES,getCourierModes),
      takeLatest(GET_ZONES,getCourierZones),
      takeLatest(GET_COURIER_SLABS, getCourierSlabs),
      takeLatest(GET_COURIER_TRIPS, getCourierTrips),
      takeLatest(POST_COURIER_TRIPS, postCourierTrips),
      takeLatest(POST_COURIER_POST_BID, courierPostBid),
		takeLatest(PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE, getCourierServiceCategory),
      takeLatest(PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE,uploadCourierServiceCategory),
      takeLatest(GET_SERVICE_CATEGORY, getServiceCategory),
      takeLatest(UPDATE_SERVICE_CATEGORY, updateServiceCategory),
      takeLatest(GET_TRANSPORTER_BID_COMMON_CHARGES, getTransporterBidCommonCharges),
      takeLatest(GET_IP_ADDRESS, getIPAddress),
      takeLatest(CLEAR_MESSAGE, clearMessage),
      takeLatest(GET_MANAGEMENT_SUMMARY_REPORT, getManagementSummaryReport),
      takeLatest(GET_PLANT_WISE_REPORT, getPlantWiseReport),
      takeLatest(GET_CURRENCY_DETAILS, getCurrencyDetails),
      takeLatest(GET_RFQ_TYPES, getRFQTypes),
      takeLatest(GET_SYSTEM_SUGGESTED_PRICE, getSystemSuggestedPrice),
      takeLatest(GET_REPORT_TEMPLATE, getReportTemplate),
      takeLatest(POST_MARKET_RATE_REPORT, getMarketRateReport),
      takeLatest(DOWNLOAD_AUDIT_TRAIL_FORM, downloadAuditTrailFormInfo),
      takeLatest(GET_MARKET_REPORT_LOCATIONS, getLocationsForReports),
      takeLatest(CHECK_CONTRACT_EXIST, checkContractExist),
      takeLatest(GET_YARD_TO_YRAD_CONSTANTS_LIST, getYardToYardConstants),
      takeLatest(CALUCALATE_FREIGHT_RATE, calculateFreightRate),
      takeLatest(GET_OTHER_LPP_DETAILS, getOtherLPPDetails),
      takeLatest(GET_AMMENDMENT_LIST_DATA, getAmmendentlist),
      takeLatest(PUT_AMMENDMENT_APPROVE_DATA, putAmmendmentApproval),
      takeLatest(DOWNLOAD_MARKET_SITE_RATE_DETAILS, downloadMarketSiteRateInfo),
      
      takeLatest(DOWNLOAD_BIDDING_RATE, getDownloadBiddingRate),
      takeLatest(UPLOAD_BIDDING_RATE, uploadBiddingRate),
      takeLatest(DOWNLOAD_TRUCKS, getDownloadTrucksDetails),
      takeLatest(UPLOAD_NUMBER_OF_TRUCKS, uploadTrucksDetails),
      takeLatest(NUMBER_OF_VEHICLE_PLACED, saveNumberOfVehiclePlaced),
      takeLatest(GET_EXISTING_CONTRACT_DETAILS, getExistingContracts),
      takeLatest(POST_GENERATE_CONTRACT_DETAILS, postGenerateContractDetails),
      takeLatest(DOWNLOAD_MULTI_MODE_CONTRACTS, downloadMultiModeContracts),
      takeLatest(UPLOAD_MULTI_MODE_CONTRACTS, uploadMultiModeContracts),
      takeLatest(GET_GENERATED_CONTRACT_DETAILS, getGeneratedContracts),
      takeLatest(GET_MULTI_MODE_CONTAINER_LIST, getMultiModeContainerTypes),
      takeLatest(GET_MULTI_MODE_MOVEMENT_TYPE_LIST, getMultiModeMovementTypes),
      takeLatest(GET_PLANT_LOCATION_LIST, getPlantLocationList),
      takeLatest(GET_DEPOT_LOCATION_LIST, getDepotLocationList),
      takeLatest(GET_CHA_LIST, getCHAList),
      takeLatest(GET_FREIGHT_DETAILS_REPORT, getFreightDetailsReport),
      takeLatest(GET_CURRENCY_TYPES, getCurrencyTypes),
      takeLatest(VENDOR_WITH_DRAW_BID, vendorWithDrawBid),
      takeLatest(REVOKE_WITHDRAW_BID, revokeWithdrawBid),
      takeLatest(CLOSED_RFQ, rfqClosed),
      takeLatest(ACCEPTANCE_CEILING_PRICE, acceptanceCeilingPrice),
      takeLatest(STATUS_GROUP, updateStatus),
      takeLatest(LOI_CANCELLED, cancelledLoi),
      takeLatest(GET_UPLOAD_PLAN, getUploadPlanList),
      takeLatest(POST_UPLOAD_PLAN, createUploadPlan),
      takeLatest(UPDATE_UPLOAD_PLAN, editUploadPlan),
      takeLatest(DELETE_UPLOAD_PLAN, deleteUploadPlan),
      takeLatest(GET_CONSIGNEE, getConsigneeList),
      takeLatest(DOWNLOAD_UP_TEMPLATE, downloadUploadPlan),
      takeLatest(UPLOAD_UP_FILE, uploadFileUP),
      takeLatest(GET_CONTRACTING_SHORT_MIS, getContractingShortMIS),
      takeLatest(DOWNLOAD_AWL_MULTIMODE_TEMPLATE, downloadAwlMultiModeTemplate),
      takeLatest(UPLOAD_AWL_MULTIMODE_TRIPS, uploadAwlMultiModeTrips),
      takeLatest(GET_LOCATION_WITH_PINCODE, getLocationWithPincode),
      takeLatest(GET_GOOGLE_STUDIO_REPORT, getGoogleStudioReport),
      takeLatest(GET_HOLISTICS_TOKEN, getHolisticsTokenMIS),
      takeLatest(GET_INCOTERMS_LIST, getIncotermsList),
      takeLatest(GET_COST_HEADS_LIST, getCostHeadList),
      takeLatest(GET_CARGO_SHIPMENT_TRACKING_DATA, getCargoShipmentTrackingData),
      takeLatest(GET_DIESEL_PRICE, getDieselPriceDetails),
      takeLatest(POST_SELECTED_BRANCH_DETAILS, postSelectedNavBranch),
      takeLatest(GET_FUEL_TYPES, getFuelTypes),
      takeLatest(REQUEST_OTP, requestOTP),
      takeLatest(LOGIN_WITH_OTP, loginWithOTP),
      takeLatest(LOGIN_WITH_SSO, loginWithSSO),
      takeLatest(VALIDATE_SSO_USER, ssoUserValidate),
      takeLatest(GET_CONTRACTING_INDENTING_MIS, getContractingIndentingReport),
      takeLatest(SSO_DELETE_TOKEN, ssoDeleteToken),
      takeLatest(GET_BROADCAST_MSG, getBroadcastMsg),
      takeLatest(GET_SPOT_CONTRACT_REASONS, getSpotContractReasons),
      takeLatest(GET_PROVIDER_TK11_MIS, getProviderTK11Mis),
      takeLatest(GET_SEA_AND_AIR_LINES_LIST, getSeaAndAirLinesList),
      takeLatest(GET_ROUTE_MASTER_DETAILS, getRouteMaster),
      takeLatest(ADD_ROUTE_MASTER_DETAILS, addRouteMaster),
      takeLatest(UPDATE_ROUTE_MASTER_DETAILS, updateRouteMaster),
      takeLatest(DELETE_ROUTE_MASTER_DETAILS, deleteRouteMaster),
      takeLatest(UPLOAD_ROUTE_MASTER_DETAILS, uploadRouteMaster),
      takeLatest(DOWNLOAD_ROUTE_MASTER_DETAILS, downloadRouteMasterDetails),
      takeLatest(DOWNLOAD_ROUTE_MASTER_TEMPLATE, downloadRouteMasterTemplate),
      takeLatest(CHECK_FTL_CONTRACT_EXIST, checkFtlContractExist),
      takeLatest(GET_CONTRACT_TENURE_LIST, getContractTenureList),
      takeLatest(POST_SHARE_OF_BUSINESS, postSOBDetails),
      takeLatest(UPDATE_DPH_DETAILS, updateDPHDetails),
      takeLatest(TRIP_LEVEL_CONTRACT_EXTENSION, postTripLevelContractExtension),
      takeLatest(TRIP_LEVEL_BID_EXTENSION, postTripLevelBidExtension),
      takeLatest(GET_SAP_ROUTE_CODES, getSAPRouteCodes),
      takeLatest(POST_REJECT_LOI_FROM_APPROVER, approverRejectsLoi),
      takeLatest(GET_SSO_CONFIG, ssoConfig),
      takeLatest(DOWNLOAD_EXISTING_CONTRACT_TEMPlATE, downloadExistingContractTemplate),
      takeLatest(UPLOAD_EXISTING_CONTRACT_DETAILS, uploadExistingContract),
      takeLatest(UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ, uploadRFQFile),
      takeLatest(POST_CREATE_INDENTS, postCreateIndents),
      takeLatest(DELETE_UPLOADED_FILE, deleteUploadedFile),
      takeLatest(POST_DPH_APPROVAL, postDPHApproval),
      takeLatest(POST_APPROVE_DPH, postApproveDPH),
      takeLatest(RETRIGGER_TK11_FOR_RFQ, retriggerTK11ForRFQ),
      takeLatest(GET_EVENT_DETAILS, getEventManagementDetails),
      takeLatest(DELETE_EVENT_DETAILS, deleteEventDetails),
      takeLatest(CREATE_NEW_EVENT, createFreshEvent),
      takeLatest(GET_RFQ_EVENT, getRFQEvent),
      takeLatest(CANCEL_EVENT, cancelEvent),
      takeLatest(POST_EVENT_DETAILS, postEventDetails),
      takeLatest(DOWNLOAD_EVENT_DETAILS_TEMPLATE, downloadEventDetailTemplate),
      takeLatest(UPLOAD_RFQS_FOR_EVENT, uploadRFQsforEvent),
      takeLatest(SCHEDULE_EVENT, scheduleEvent),
      takeLatest(GET_EVENT_STATUS, getEventStatus),
      takeLatest(GET_EVENT_RFQ_TRIPS, getEventRFQTrips),
      takeLatest(UPDATE_EVENT_RFQ, updateEventRFQ),
      takeLatest(UPDATE_EVENT_RFQ_TRIPS, updateEventRFQTrips),
      takeLatest(UPLOAD_SOB_DETAILS, uploadSOBDetails),
      takeLatest(DOWNLOAD_SOB_TEMPLATE, downloadSOBTemplate),
      takeLatest(GET_WINNING_TRANSPORTERS, getWinningTransporters),
      takeLatest(DELETE_TRANSPORTER_IN_WINNIG_PAGE, deleteTransporterInWinningPage),
      takeLatest(POST_WISHLIST_EVENT, postWishlistEvent),
      takeLatest(GET_FTL_CONTRACT_TYPE, getFTLContractTypes),
      takeLatest(DOWNLOAD_OFFLINE_SLABEWISE_TRIPS, downloadOfflineSlabWiseTrips),
      takeLatest(UPLOAD_OFFLINE_SLABEWISE_TRIPS, uploadOfflineSlabWiseTrips),
      takeLatest(GET_ALL_MASTER_CONTRACTS, getMasterContracts),
      takeLatest(GET_FROM_ROUTE, getFromRoutes),
      takeLatest(GET_BRANCH_YARD_FILTERS, getBranchYardFilters),
      takeLatest(POST_SEARCH_ROUTES_CONTRACTS, postSearchRoutes),
      takeLatest(GET_YARD_LOCATIONS, getYardLocations),
      takeLatest(GET_GENERATE_ROUTE_CODE, getGenerateRouteCodes),
      takeLatest(ADD_ADDITIONAL_TRANSPORTER_DURING_BIDDING, addAdditionalTransporter),
      takeLatest(GET_RFQ_LEVEL_PR_DETAILS, getRfqlevelPRDetails),
      takeLatest(GET_TRANSPORTER_LEVEL_PR_DETAILS, getTransporterlevelPRDetails),
      takeLatest(DOWNLOAD_PR_DETAILS, downloadPRDetails),
      takeLatest(GET_CLUSTER_DETAILS, getClusterDetails),
      takeLatest(GENERATE_PLAN_IN_MASTER_CONTRACT, generatePlanInMasterContract),
      takeLatest(GET_CONTRACT_DETAILS, getContractDetails),
      takeLatest(GET_CHILD_CONTRACT_TK11, getChildContractTk11),
      takeLatest(GET_MASTER_CONTRACT_TK11, getMasterContractTk11),
      takeLatest(GET_ZONE_WISE_DETAILS, getZoneWiseDetails),
      takeLatest(GET_COMPANY_BRANCH_DETAILS, getCompanyBranchDetails),
      takeLatest(GET_VENDOR_BIDDING_STATUS, getVendorBiddingStatus),
      takeLatest(UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS, updateRFQLevelVendorBiddingStatus),
      takeLatest(UPLOAD_OTHER_CHARGES, uploadOtherCharges),
      takeLatest(GET_OTHER_CHARGES_TEMPLATE, getOtherChargesTemplate),
      takeLatest(UPDATE_POST_BID_TO_PRE_BID_RFQ, updatePostBidToPreBidRFQ),
      takeLatest(DOWNLOAD_TRANSPORTER_WISE_BID_DETAILS, downloadTransporterWiseBidDetails),
      takeLatest(RETRIGGER_MASTER_CONTRACTS_TK11, retriggerMasterContract),
      takeLatest(SAVE_RETRIGGER_MC_TK11, saveRetriggerMasterContract),
      takeLatest(GET_LOCATION_DROPDOWN_VALUES, getLocationDropdownValues),
      takeLatest(GET_MASTER_ROUTE_CODE_DETAILS, getMasterRouteCodeDetails),
      takeLatest(GET_SECONDARY_CONTRACTS_LIST, getSecondaryContractlist),
      takeLatest(GET_VENDOR_LIST, getVendorList),
      takeLatest(DOWNLOAD_SECONDARY_CONTRACT_TEMPLATE, downloadTripsSecondaryContractsTripsTemplate),
      takeLatest(UPLOAD_SECONDARY_CONTRACT_TRIPS, uploadSecondaryContractsTrips),
      takeLatest(SAVE_SECONDARY_CONTRACTS, saveSecondaryContracts),
      takeLatest(DELETE_SECONDARY_CONTRACT_RFQ, deleteSecondaryContractRFQ),
      takeLatest(DELETE_SECONDARY_CONTRACT_RFQ_TRIP, deleteSecondaryContractRFQTrips),
      takeLatest(GET_CONTRACT_BY_RFQId, getContractByRFQId),
      takeLatest(GET_SECONDARY_CONTRACT_CFA_DETAILS, getCFADetails),
      takeLatest(UPDATE_SECONDARY_CONTRACTS, updateSecondaryContrats),
      takeLatest(MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL, multiContractSendLoiForApproval),
      takeLatest(APPROVE_MULTI_CONTRACT, approveMultiContract),
      takeLatest(REJECT_MULTI_CONTRACT, rejectMultiContract),
      takeLatest(DOWNLOAD_MULTI_CONTRACT_TEMP, downloadMultiContractTemplate),
      takeLatest(UPLOAD_MULTI_CONTRACT, uploadMultiContract),
      takeLatest(GET_MULTI_CONTRACT_DETAILS, getMultiContracts),
      takeLatest(DELETE_MULTI_CONTRACT, deleteMultiContract),
      takeLatest(GET_MULTI_CONTRACT_TYPES, getMultiContractTypes),
      takeLatest(UPDATE_MULTI_CONTRACT, updateMultiContract),
      takeLatest(GET_TRIP_TYPES, getTripTypes),
      // takeLatest(UPLOAD_CONTAINER_TRIPS, uploadContainerTrips),
      // takeLatest(DOWNLOAD_CONTAINER_TEMPLATE, downloadContainerTripsTemplate),
      // takeLatest(GET_CONTAINER_TRIPS, getContainerTrips),
      // takeLatest(POST_CONTAINER_TRIPS, postContainerTrips),
      // takeLatest(GET_CONTAINER_LPP, getConatinerLPP),
      takeLatest(UPLOAD_EXTISTING_TRIPS_REMARKS, uploadExistingTripsRemarks),
      takeLatest(DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE, downloadExistingTripsRemarks),
      takeLatest(GET_CONTAINER_TYPES, getContainerTypes),
      takeLatest(GET_CONTAINER_TYPES_LIST, getContainerListType),
      takeLatest(GET_MULTI_MODE_ROUTE_CODE, getMultiModeRouteCode),
      takeLatest(UPLOAD_CONTAINER_TRIPS, uploadContainerTrips),
      takeLatest(DOWNLOAD_CONTAINER_TEMPLATE, downloadContainerTripsTemplate),
      takeLatest(GET_CONTAINER_TRIPS, getContainerTrips),
      takeLatest(POST_CONTAINER_TRIPS, postContainerTrips),
      takeLatest(GET_CONTAINER_LPP, getConatinerLPP),
      takeLatest(DOWNLOAD_UPLOADED_FILE, downloadUploadedFile),
      takeLatest(POST_OFFLINE_CONTRACTS_UPDATED_DETAILS, postOfflineContractsUpdatedDetails),
      takeLatest(GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE,  downloadOfflineContractsDetails),
      takeLatest(POST_TRIP_FILE_REMARKS, postTripFileRemarks),
      takeLatest(GET_REGION_NAMES, getStatesDropdown),
      takeLatest(UPLOAD_EXTISTING_TRIPS_REMARKS, uploadExistingTripsRemarks),
      takeLatest(DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE, downloadExistingTripsRemarks),

      // Multimodal rate comparison saga start here

      takeLatest(GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST,
         getMultimodeRateComparisonSoureDestinationList),
      takeLatest(GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST,
         getMultimodeRateComparisonCommodityCategoryList),
      takeLatest(GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST,
         getMultimodeRateComparisonFreightRateList),
      takeLatest(GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST,
         getMultimodeRateComparisonFreightDaysList),
      takeLatest(GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST,
         getMultimodeRateComparisonVehicleDetailsList),
      takeLatest(GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST,
         getMultimodeRateComparisonViewDetailsRoadFreightRateList),
      takeLatest(GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST,
         getMultimodeRateComparisonViewDetailsRailFreightRateList),
      takeLatest(GET_RAIL_RAKE_LIST, getRailRakeList),

      takeLatest(GET_ORIGIN_DESTINATION_YARD_LIST, getOriginDestinationYardList),
     // Multimodal rate comparison saga end here

     // New exim cargo tracking saga start here

      takeLatest(GET_EXIM_CARGO_TEMPLATE,getEximCargoTemplate),
      takeLatest(UPLOAD_EXIM_CARGO_TEMPLATE,uploadEximCargoTemplate),
      takeLatest(GET_EXIM_CONTAINER_BL_TRACKING_DETAILS,getEximContainerBlTrackingDetails),
      takeLatest(GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
           getEximCargoSourceDestinationPortAndStatus),
      takeLatest(GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
           getEximContainerBlTrackingDetailsTemplate),
      takeLatest(SAVE_EXIM_CONTAINER_SKU_DETAILS,saveEximCargoDetailsSkuDetails),

      // New exim cargo tracking saga end here

      // takeLatest(POST_ACCEPT_CEILING_PRICE_LOI, postAcceptCeilingPriceLOI)
    

      takeLatest(POST_TRIP_FILE_REMARKS, postTripFileRemarks),
      takeLatest(GET_REGION_NAMES, getStatesDropdown),

      // Supplier Or Transportation Requests Dashboard saga start here 

      // takeLatest( , ),
   
      // Supplier Or Transportation Requests Dashboard saga end here 

      
      // Supplier RFQ Create Request saga start here 

        takeLatest(GET_CONSIGNOR_PICKUP_LOCATION_LIST, getConsignorPickupLocationList),
        takeLatest(GET_SERVICE_TYPES_LIST, getServiceTypesList),
        takeLatest(GET_SERVICE_MODE_TYPES_LIST, getServiceModeTypesList),
        takeLatest(GET_CARGO_DETAILS_TYPES_LIST, getCargoDetailsTypesList),
        takeLatest(GET_CARGO_MATERIAL_PACKING_TEMAPLATE, getCargoMaterialPackingTemaplate),
        takeLatest(UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE, uploadCargoMaterialPackingTemaplate),
        takeLatest(GET_HANDLING_INSTRUCTION_TYPES_LIST, getHandlingInstructionTypesList),
        takeLatest(GET_VEHICLE_TYPES_LIST, getVehicleTypesList),
        takeLatest(CREATE_SUPPLIER_CONTRACT, createSupplierContract),
        takeLatest(GET_PACKING_TYPES_LIST, getPackingTypesList),
        takeLatest(GET_SUPPLIER_DETAILS_RFQ, getSupplierDetailsRfq),
        takeLatest(UPDATE_SUPPLIER_CONTRACT_DETAILS, updateSupplierContractDetails),
        takeLatest(DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS, deleteSupplierContractRfqDetails),

      // Supplier RFQ Create Request saga end here 

       // Supplier Or TransportationRequestsDashboard saga start here

        takeLatest(GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS, getSupplierTransportationContractsDetails),
        takeLatest(GET_SUPPLIER_NAME_LIST, getSupplierNameList),
        takeLatest(CREATE_TRANSPORTATION_RFQ, createTransportationRfq),
        takeLatest(GET_TRANSPORTER_MAPPING_LIST, getTransporterMappingList),
        takeLatest(GET_PROVIDER_MATERIAL_PACKING_DETAILS, getProviderMaterialPackingDetails),

       // Supplier Or TransportationRequestsDashboard saga end here
       
         takeLatest(POST_OVERALL_ALLOCATION, postOverallAllocation),
         // takeLatest(UPLOAD_TARGET_PRICE, uploadTargetPrice),
         // takeLatest(DOWNLOAD_TARGET_PRICE, downloadTargetPrice),
         takeLatest(GET_SEARCHED_SECONDARY_CONTRACT_RFQ_TRIPS, getSearchedSecondaryCotractRfqTrips),
         takeLatest(GET_SOURCE_ICD_BRANCH_LIST, getSourceICDBranches),
         takeLatest(GET_ALL_ICD_BRANCH_LIST, getAllICDBranches),
         takeLatest(GET_ICD_DESTINATION_ROUTE_CODE, getICDDestinationRouteCode),

         // FOSROC - Extend the Bid Time for the Single Bided Trips Sagas start here
         takeLatest(EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS, updateSingleBiddedTripsTime),
         // FOSROC - Extend the Bid Time for the Single Bided Trips Sagas end here

      takeLatest(GET_CONSIGNEE_DETAILS_BY_NAME, getConsigneeDetailsByName),
      takeLatest(GET_SEEKER_COMPANY_LIST, getSeekerCompanylist),
      takeLatest(VALIDATE_FORGOT_PASSWORD, validateForgotPassword),
      takeLatest(SECONDARY_CONTRACT_TENURE_VALIDATION, postSecondaryContractValidation),
      takeLatest(POST_ON_DEMAND_TRACKING, postOnDemandTracking),
      takeLatest(GET_PORT_DETAILS, getPortDetails),
      takeLatest(GET_EXIM_LPP_DETAILS, getEximLppDetails),
      takeLatest(REACTIVATE_TK11, reactivateTk11),
      poDetailsSaga(),
      commonSaga(),
      takeLatest(GET_EXIM_AWL_PLANT_WISE_COST_HEADS, getEXIMAWLPlantWiseCostHeads),
      takeLatest(GET_TRIPS_LOG, getTripsErrorLogs),
      takeLatest(DELETE_CONTRACT_RECORD, deleteContractRecord),
      transportationManagementSaga(),
      takeLatest(GET_TERMS_AND_CONDITIONS, getTermsAndConditions),
      takeLatest(POST_TOLL_TAX_UPDATE_PRICE, postTollTaxUpdatePrice),
   ]);
});
